import { lazy } from "react";
import { Navigate } from "react-router-dom";
import AuthGuard from "../gaurds/AuthGuard";
import GuestGuard from "../gaurds/GuestGuard";
import MainLayout from "../layout/MainLayout";

export const AdminRoutes = [
  // Projects
  {
    exact: true,
    path: "/projects",
    component: lazy(() => import("../views/Projects/Projects")),
  },
  {
    exact: true,
    path: "/projects/:id/media",
    component: lazy(() => import("../views/ProjectMedia/ProjectMedia")),
  },
  {
    exact: true,
    path: "/projects/:id/surveys",
    component: lazy(() => import("../views/ProjectSurveys/ProjectSurveys")),
  },
  // Booths
  {
    exact: true,
    path: "/projects/:projectId/booths",
    component: lazy(() => import("../views/Booths/Booths")),
  },
  {
    exact: true,
    path: "/projects/:projectId/booths/:boothId/media",
    component: lazy(() => import("../views/BoothMedia/BoothMedia")),
  },
  {
    exact: true,
    path: "/projects/:projectId/booths/:boothId/surveys",
    component: lazy(() => import("../views/BoothSurveys/BoothSurveys")),
  },
  // Advertisements
  {
    exact: true,
    path: "/advertisements",
    component: lazy(() => import("../views/Advertisements/Advertisements")),
  },
  // Error Page
  {
    path: "*",
    exact: true,
    component: () => <Navigate to={"/404"} />,
  },
];

const routes = [
  // Error Page
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("../views/Error/Error")),
  },
  // Login Page
  {
    exact: true,
    guard: GuestGuard,
    path: "/",
    component: lazy(() => import("../views/Login/Login")),
  },
  // Gallery
  {
    exact: true,
    path: "/gallery",
    layout: MainLayout,
    component: lazy(() => import("../views/Gallery/Gallery")),
  },
  // Interactive Video
  {
    exact: true,
    path: "/interactive-video",
    layout: MainLayout,
    component: lazy(() => import("../views/InteractiveVideo/InteractiveVideo")),
  },
  {
    exact: true,
    path: "/interactive-subVideo",
    layout: MainLayout,
    component: lazy(() =>
      import("../views/SubInteractiveVideo/SubInteractiveVideo")
    ),
  },
  {
    exact: true,
    path: "/interactive-video-frame",
    // layout: MainLayout,
    component: lazy(() =>
      import("../views/InteractiveVideoIframe/InteractiveVideoIframe")
    ),
  },

  // Spinning Wheel
  {
    exact: true,
    path: "/spinning-wheel",
    layout: MainLayout,
    component: lazy(() => import("../views/SpinningWheel/ChoseWheel")),
  },
  {
    exact: true,
    path: "/get-wheel/:Id",
    component: lazy(() => import("../views/SpinningWheel/SpinningWheel")),
  },
  // Dashboard Layout (Logged in routes)
  {
    path: "*",
    layout: MainLayout,
    guard: AuthGuard,
    routes: AdminRoutes,
  },

  {
    exact: true,
    path: "/ThreePartLayout",
    component: lazy(() => import("../views/ThreePartLayout/ThreePartLayout")),
  },
];

export default routes;
